import { Link } from "react-router-dom";
import { Calendar, Tag, ConfigProvider, Spin, Checkbox, Modal, Typography, Card, Row, Col } from "antd";
import es_ES from "antd/es/locale/es_ES";
import { EditFilled, BellFilled } from "@ant-design/icons";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";

export default function CalendarView() {
  const [loading, setLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState();
  const [dates, setDates] = useState();
  const [filters, setFilters] = useState(["visita", "solicitud", "contrato"]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedVerification, setSelectedVerification] = useState(null);
  const [selectedVisitas, setSelectedVisitas] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedItemType, setSelectedItemType] = useState(null);

  const onSelect = (value) => {
    // setLoading(true);
    // setSelectedValue(value);
  };

  const onPanelChange = (value) => {
    setLoading(true);
    setSelectedValue(value);
    setLoading(false);
  };

  const formatControlInterno = (value) => {
    if (value === null) {
      return "N/D";
    } else if (value.includes("/")) {
      const firstPart = value.split("/")[0];
      if (firstPart === "") {
        return value;
      } else {
        return firstPart;
      }
    } else {
      return value;
    }
  };

  useEffect(() => {
    const promises = [];
    if (filters.includes("visita")) {
      promises.push(
        axios.get(
          `${process.env.REACT_APP_API_URL}/verificaciones/calendario/visitas/
        ${moment(selectedValue).format("YYYY")}/
        ${moment(selectedValue).format("MM")}`
        )
      );
    }
    if (filters.includes("solicitud")) {
      promises.push(
        axios.get(
          `${process.env.REACT_APP_API_URL}/verificaciones/calendario/solicitud/
        ${moment(selectedValue).format("YYYY")}/
        ${moment(selectedValue).format("MM")}`
        )
      );
    }
    if (filters.includes("contrato")) {
      promises.push(
        axios.get(
          `${process.env.REACT_APP_API_URL}/verificaciones/calendario/contrato/
        ${moment(selectedValue).format("YYYY")}/
        ${moment(selectedValue).format("MM")}`
        )
      );
    }

    Promise.all(promises)
      .then((responses) => {
        let dates = [];
        responses.forEach((response) => {
          const newDates = response.data.map((date) => ({
            id: date.id,
            ControlInterno: date.ControlInterno,
            Municipio: date.Municipio,
            Fecha: date.Fecha.substring(0, 10),
            Hora1: date.Hora1,
            Hora2: date.Hora2,
            Tipo: date.Tipo,
          }));
          dates = dates.concat(newDates);
        });

        dates.sort((a, b) => {
          return a.ControlInterno - b.ControlInterno;
        });
        setDates(dates);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedValue, filters]);

  useEffect(() => {
    if (selectedItemId) {
      setLoadingModal(true);
      axios
        .get(`${process.env.REACT_APP_API_URL}/verificaciones/${selectedItemId}`)
        .then((response) => {
          setSelectedVerification(response.data[0]);
          if (selectedItemType === "visita") {
            axios
              .get(`${process.env.REACT_APP_API_URL}/visitas/${selectedItemId}`)
              .then((visitaResponse) => {
                setSelectedVisitas(visitaResponse.data);
                setLoadingModal(false);
              });
          } else {
            setLoadingModal(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching verification data:", error);
          setLoadingModal(false);
        });
    }
  }, [selectedItemId, selectedItemType]);

  const dateCellRender = (value) => {
    const listData = dates?.filter(
      (date) =>
        moment(date.Fecha).format("YYYY-MM-DD") === value.format("YYYY-MM-DD") &&
        filters.includes(date.Tipo)
    );
    return (
      <div>
        {listData?.map((item) => (
          <span
            key={listData.indexOf(item)}
            onClick={() => {
              setSelectedItemId(item.id);
              setSelectedItemType(item.Tipo);
              setIsModalVisible(true);
            }}
          >
            {item.Tipo === "visita" ? (
              <span
                style={{
                  backgroundColor: "#f1f1f1",
                  color: "#001529",
                  padding: "0 5px",
                  marginBottom: "2px",
                  display: "flex",
                  justifyContent: "space-between",
                  borderLeft: "4px solid #1890FF",
                }}
              >
                <div>
                  <span style={{ fontWeight: "bold" }}>{formatControlInterno(item.ControlInterno)}</span>
                  <span style={{ marginLeft: "5px" }}>
                    {item.Hora1 ? moment(item.Hora1, "HH:mm").format("HH:mm") : null}-
                    {item.Hora2 ? moment(item.Hora2, "HH:mm").format("HH:mm") : null}
                  </span>
                </div>
                <span>
                  {item.Municipio ? item.Municipio.replace(/\s/g, '').substring(0, 4) : null}
                </span>
              </span>
            ) : item.Tipo === "solicitud" ? (
              <Tag color="DodgerBlue  ">
                <span style={{ marginLeft: "5px" }}>
                  <BellFilled />
                  {formatControlInterno(item.ControlInterno)}
                </span>
              </Tag>
            ) : item.Tipo === "contrato" ? (
              <Tag color="MediumPurple">
                <EditFilled />
                <span style={{ marginLeft: "5px" }}>{formatControlInterno(item.ControlInterno)}</span>
              </Tag>
            ) : null}
          </span>
        ))}
      </div>
    );
  };

  const generalFields = [
    { key: "FechaContrato", label: "Fecha de Contrato" },
    { key: "FechaRecepcion", label: "Fecha de Solicitud" },
    { key: "DescripcionBreve", label: "Descripción Breve" },
    { key: "Monto", label: "Monto" },
  ];
  const clienteFields = [
    { key: "NombreCompletoPV", label: "Razón Social" },
    { key: "Cliente", label: "Cliente" },
  ];
  const ubicacionFields = ["NombreCalle", "NumeroOficial", "ColoniaOAsentamiento", "Municipio", "Estado"];
  const instalacionFields = [
    { key: "TensionElectricaSuministro", label: "Tensión Eléctrica de Suministro", suffix: "V" },
    { key: "CargaInstalada", label: "Carga Instalada", suffix: "kW" },
    { key: "AlcanceVerificacion", label: "Alcance de la Verificación", suffix: "kW" },
    { key: "Capacidad", label: "Capacidad de la Subestación", suffix: "kVA" },
  ];
  const visitaFields = [
    { key: "FechaVisita", label: "Fecha de Visita" },
    { key: "HoraInicio", label: "Hora de Inicio" },
    { key: "HoraTermino", label: "Hora de Término" },
  ];

  return (
    <ConfigProvider locale={es_ES}>
      <Spin
        spinning={loading}
        //center the spinner vertically and horizontally
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="calendar-container">
          <div style={{ marginBottom: "10px", padding: "10px", border: "1px solid #f0f0f0", borderRadius: "2px" }}>
            <div style={{ fontWeight: "bold", marginBottom: "5px" }}>Filtros</div>
            <Checkbox.Group value={filters} onChange={setFilters}>
              <Checkbox value="visita">Visitas</Checkbox>
              <Checkbox value="solicitud">Solicitudes</Checkbox>
              <Checkbox value="contrato">Contratos</Checkbox>
            </Checkbox.Group>
            <div style={{ marginTop: "10px" }}>
              <div style={{ fontWeight: "bold", marginBottom: "5px" }}>Leyenda</div>
              <div><Tag color="#1890FF">Visita</Tag> <Tag color="DodgerBlue">Solicitud</Tag> <Tag color="MediumPurple">Contrato</Tag></div>
            </div>
          </div>
          <Calendar
            fullscreen={true}
            dateCellRender={dateCellRender}
            onSelect={onSelect}
            onPanelChange={onPanelChange}
            locale={{
              lang: {
                locale: "es_ES",
                dayFormat: moment.updateLocale("es_ES", {
                  weekdaysMin: ["Dom.", "Lun.", "Mar.", "Mié.", "Jue.", "Vie.", "Sáb."],
                }),
              },
            }}
          />
        </div>
      </Spin>
      <Modal
        title="Detalles de la Verificación"
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedItemId(null);
          setSelectedItemType(null);
          setSelectedVerification(null);
          setSelectedVisitas([]);
        }}
        width={1000}
      >
        {loadingModal ? (
          <Spin />
        ) : (
          <div>
            {selectedVerification && (
              <>
                <Typography.Title level={4}>
                  {selectedVerification.ControlInterno}
                </Typography.Title>
                <Typography.Text type="secondary">
                  Creado el: {selectedVerification.FechaCreacion}
                </Typography.Text>
                <Link to={`/verificaciones/${selectedItemId}`} style={{ display: 'block', marginBottom: '20px' }}>
                  Ir a la verificación
                </Link>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <Card title="Datos Generales">
                      <ul>
                        {generalFields.map(({ key, label }) => (
                          <li key={key}>
                            <strong>{label}:</strong> {selectedVerification[key]}
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card title="Cliente">
                      <ul>
                        {clienteFields.map(({ key, label }) => (
                          <li key={key}>
                            <strong>{label}:</strong> {selectedVerification[key]}
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                  <Col span={12}>
                    <Card title="Ubicación">
                      <p>
                        {selectedVerification.NombreCalle} {selectedVerification.NumeroOficial}, {selectedVerification.ColoniaOAsentamiento}, {selectedVerification.Municipio}, {selectedVerification.Estado}
                      </p>
                    </Card>
                  </Col>
                  <Col span={12}>
                    <Card title="Instalación">
                      <ul>
                        {instalacionFields.map(({ key, label, suffix }) => (
                          <li key={key}>
                            <strong>{label}:</strong> {selectedVerification[key]} {suffix}
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
            {selectedVisitas.length > 0 && (
              <Card title="Visita(s)" style={{ marginTop: "20px" }}>
                {selectedVisitas.map((visita, index) => (
                  <div key={index}>
                    <h4>Visita {index + 1}</h4>
                    <ul>
                      {visitaFields.map(({ key, label }) => (
                        <li key={key}>
                          <strong>{label}:</strong> {visita[key]}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </Card>
            )}
          </div>
        )}
      </Modal>
    </ConfigProvider>
  );
}